import * as Yup from 'yup';
import type { PasswordRequirements } from '@/services/forgot-password.types';

const DIGIT_RE = /\d/;
const SPECIAL_CHAR_RE = /[^A-Za-z0-9]/;

const getResetPasswordSchema = (requirements?: PasswordRequirements) => {
  const base = Yup.string().required();

  const password = requirements
    ? base
        .min(requirements.minLength, {
          key: 'form.validation.passwordMinLength',
          values: { length: requirements.minLength },
        } as unknown as string)
        .test(
          'password-digit',
          { key: 'form.validation.passwordRequiresDigit' } as unknown as string,
          (value) =>
            !requirements.digitRequired || (!!value && DIGIT_RE.test(value)),
        )
        .test(
          'password-special-char',
          {
            key: 'form.validation.passwordRequiresSpecialChar',
          } as unknown as string,
          (value) =>
            !requirements.specialCharacterRequired ||
            (!!value && SPECIAL_CHAR_RE.test(value)),
        )
    : base;

  return Yup.object({
    password,
    confirmPassword: Yup.string()
      .required()
      .test(
        'passwords-match',
        { key: 'form.validation.passwordsMustMatch' } as unknown as string,
        function (value) {
          return this.parent.password === value;
        },
      ),
  });
};

export type ResetPasswordSchemaType = Yup.InferType<
  ReturnType<typeof getResetPasswordSchema>
>;

export default getResetPasswordSchema;
